import { text as textFactory } from '../../next-schema/generated/nodeTypes';

/**
 * @name text_node
 */

export const text = textFactory({
  toDebugString: process.env.NODE_ENV !== 'production' ? undefined : () => 'text_node'
});